import React from 'react';
import { Upload, message } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

class FileUpload extends React.Component {
  state = {
    loading: false,
  };

  handleChange = info => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl =>
        this.setState({
          imageUrl,
          loading: false,
        }),
      );
    }
  };

  render() {
    const { createImageDataFromFileData } = this.props;
    // const { getImage } = useCanvasImage();

    const { loading, imageUrl } = this.state;
    const uploadButton = (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );

    const beforeUpload = function(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
      }
      const isLt2M = file.size / 1024 / 1024 < 128;
      if (!isLt2M) {
        message.error('Image must smaller than 128MB!');
      }
      if (!isJpgOrPng || !isLt2M) {
        console.log('Upload is not valid');
        return false;
      } else {
        const reader = new FileReader();
        // reader.readAsDataURL(file);
        reader.readAsDataURL(file);
        reader.onload = () => {
          const fileData = reader.result;
          createImageDataFromFileData(fileData);
          // drawImage();
        };
      }
    }

    return (
      <Upload
        name="avatar"
        // listType="picture-card"
        className="avatar-uploader"
        // showUploadList={false}
        // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        fileList={[]}
        beforeUpload={beforeUpload}
        onChange={() => {}}
      >
        {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
      </Upload>
    );
  }
}

export default FileUpload;
